import type { WebappConfig, WebappGlobalConfig } from "@pandas/platform-types/configurator";
import { webappGlobalSchema, webappSchema } from "@pandas/platform-types/configurator";

// The webapp and webappGlobal module schemas are defined once in
// @pandas/platform-types/configurator, alongside the configurator UI that authors them.
export { webappGlobalSchema, webappSchema };

export type ConfiguratorConfig = WebappConfig;
export type ConfiguratorAppGlobalConfig = WebappGlobalConfig;

// ─── Initial States ───────────────────────────────────────────────────────────

// Parsing an empty object materialises every schema default, so the store starts from
// the same values the configurator would serve before a partner config loads.
export const configurationInitialState: ConfiguratorConfig = webappSchema.parse({});
export const globalConfigurationInitialState: ConfiguratorAppGlobalConfig = webappGlobalSchema.parse({});
